import type { IdeaLabEntryCoverageSummary } from '@einhaus/project314-types';

type CoverageReason = IdeaLabEntryCoverageSummary['byReason'][number]['reason'];

const COVERAGE_REASON_LABELS: Record<CoverageReason, string> = {
    invalid_price: 'Price-quality hold',
    confirmed_missing: 'Source bars confirmed missing',
    repair_pending: 'Source bars awaiting repair',
    unavailable_required_evidence: 'Required evidence unavailable',
    // Runs evaluated before the 2026-11-03 worker release kept no specific reason.
    missing_required_bars: 'Required history unavailable'
};

export const coverageReasonLabel = (reason: CoverageReason): string => COVERAGE_REASON_LABELS[reason];

/** Shared by the report and its copied completion summary; counts retain their actual units. */
export const describeEntryCoverage = (coverage: IdeaLabEntryCoverageSummary): string => {
    const { population } = coverage;
    const parts = [
        `${population.evaluatedEntityCount} of ${population.requestedEntityCount} requested entities evaluated`,
        `${population.excludedEntityCount} whole entities excluded`
    ];
    if (population.failedEntityCount > 0) parts.push(`${population.failedEntityCount} entities failed`);
    parts.push(`${coverage.skippedSessionCount.toLocaleString('en-US')} symbol-sessions excluded within evaluated entities`);
    if (coverage.skippedSessionCount > 0) {
        parts.push(`${coverage.firstSessionDate} to ${coverage.lastSessionDate}`);
        parts.push(
            coverage.byReason
                .map((row) => `${coverageReasonLabel(row.reason)}: ${row.skippedSessionCount.toLocaleString('en-US')}`)
                .join('; ')
        );
    }
    return `${parts.join(' · ')}.`;
};
